import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { Button } from './ui/button';
import { ArrowRight, Code2 } from 'lucide-react';
import TerminalAnimation from './TerminalAnimation';
import portraitTech from '../assets/patrizio-portrait-tech.png';
import DataNetworkBackground from './DataNetworkBackground';
import HealthcareDataVisual from './HealthcareDataVisual';

const Hero = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

	  return (
	    <section id="hero" className="brutalist-section dark isolate border-t-0 min-h-screen pt-24 relative overflow-hidden">
	      <DataNetworkBackground className="absolute inset-0 z-0 h-full w-full pointer-events-none" />
	      <div className="brutalist-container relative z-10">
	        <div className="grid lg:grid-cols-[1fr_auto] gap-10 lg:gap-12 items-start">
	          {/* Text Content */}
	          <div data-reveal="out" className="space-y-8" style={{ '--reveal-delay': '0ms' }}>
            <div className="inline-flex items-center border border-border px-3 py-1">
              <span className="brutalist-kicker">{t.hero.greeting}</span>
            </div>
            <h1 className="font-mono text-4xl sm:text-5xl md:text-7xl font-semibold leading-[1.02] tracking-tight">
              {t.hero.name}
            </h1>
            <div className="space-y-4">
              <h2 className="font-mono text-lg sm:text-xl md:text-2xl tracking-[0.08em]">
                {t.hero.title}
              </h2>
              <p className="text-lg leading-relaxed max-w-prose">
                {t.hero.subtitle}
              </p>
              <p className="text-muted-foreground leading-relaxed max-w-prose">
                {t.hero.description}
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 pt-2">
              <Button
                onClick={() => scrollToSection('contact')}
                size="lg"
              >
                {t.hero.cta}
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <Button
                onClick={() => scrollToSection('projects')}
                variant="outline"
                size="lg"
              >
                {t.hero.viewWork}
                <Code2 className="ml-2 w-5 h-5" />
              </Button>
            </div>

            {/* Tech badges */}
            <div className="flex flex-wrap gap-2 pt-4">
              {['React', 'Python', 'Power BI', 'PostgreSQL'].map((tech, idx) => (
                <span
                  key={idx}
                  className="font-mono text-xs tracking-[0.14em] border border-border px-3 py-1"
                >
                  {tech}
                </span>
              ))}
            </div>

	          </div>

	          {/* Image with tech overlay */}
	          <div
	            data-reveal="out"
	            className="flex justify-center lg:justify-end relative"
	            style={{ '--reveal-delay': '80ms' }}
	          >
	            <div className="relative">
	              <img
	                src={portraitTech}
	                alt={
	                  language === 'de'
	                    ? 'Professionelles Porträt von Patrizio Sbardella'
	                    : 'Professional portrait of Patrizio Sbardella'
	                }
	                className="relative block w-full max-w-[340px] sm:max-w-[360px] lg:max-w-[400px] h-auto border border-foreground"
	                loading="eager"
	                decoding="async"
	              />
	              <TerminalAnimation />

	              {/* Small Hero-like accent near the photo (hover morph) */}
	              <div className="mt-4 flex justify-start lg:justify-end">
	                <div className="inline-flex items-center gap-3 border border-border bg-background/90 px-3 py-2">
	                  <span className="font-mono text-[10px] tracking-[0.32em] uppercase text-muted-foreground hidden sm:inline">
	                    Healthcare → Analytics
	                  </span>
	                  <HealthcareDataVisual size="sm" />
	                </div>
	              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
